import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from './usersSlice';

interface AuthState {
  isLogin: boolean;
  user: User;
}

const initialState: AuthState = {
  isLogin: false,
  user: {
    id: '',
    pw: '',
    cart: [],
  },
};

// TODO: 로그아웃 시 user의 장바구니가 초기화되는 문제 발생,
// thunk나 saga 같은 비동기 액션 미들웨어를 통해 해결 가능한지 알아볼 것.
const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    login: (state, action: PayloadAction<User>) => {
      state.isLogin = true;
      state.user = action.payload;
    },
    logout: (state) => {
      state.isLogin = false;
      state.user = {
        id: '',
        pw: '',
        cart: [],
      };
    },

    addCart: (state, action: PayloadAction<number>) => {
      if (state.isLogin && state.user.cart) {
        state.user.cart.push({ productId: action.payload }); // (productId: 인자로 받은 payload)를 push한다.
      }
    },

    removeCart: (state, action: PayloadAction<number>) => {
      if (state.isLogin && state.user.cart) {
        state.user.cart = state.user.cart.filter((product) => product.productId !== action.payload);
      }
    },
  },
});

export const { login, logout, addCart, removeCart } = authSlice.actions;

export default authSlice.reducer;
